import { Amplify } from 'aws-amplify';
import type { IAmplifyConfig, ICookieConfig } from 'packages/workspace/modules/algebra/interfaces/IAmplifyConfig';
import type { IOrganizationWorkspaceResource } from 'packages/workspace/modules/algebra/interfaces/IOrganizationWorkspaceResource';
import { AuthConfig } from '../config';

/**
 * Used to Set Amplify Configuration Overall.
 * @param host
 * @param context
 * @param data
 */
export const configureAmplify = async (host: string, data: IOrganizationWorkspaceResource): Promise<void> => {
  const amplifyConfig: IAmplifyConfig = {
    aws_project_region: data.organizationSettings.security_authentication_aws_cognito_project_region,
    aws_cognito_region: data.organizationSettings.security_authentication_aws_cognito_cognito_region,
    aws_user_pools_id: data.organizationSettings.security_authentication_aws_cognito_user_pools_id,
    aws_user_pools_web_client_id: data.workspaceSettings.security_authentication_aws_cognito_application_client_id,
  };

  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: data.organizationSettings.security_authentication_aws_cognito_identity_pool_id,
        userPoolId: data.organizationSettings.security_authentication_aws_cognito_user_pools_id,
        userPoolClientId: data.workspaceSettings.security_authentication_aws_cognito_application_client_id,
        loginWith: {
          oauth: {
            domain: 'rainn-rhs.auth.us-west-2.amazoncognito.com',
            scopes: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [`https://${host}/auth/auth.page`],
            redirectSignOut: [`https://${host}`],
            responseType: 'code',
          },
        },
      },
    },
    ...amplifyConfig,
  }, {
    ssr: true,
  });
};